// @ts-strict-ignore
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ProfileElementSchema } from "../models/profile-element.model";

@Injectable({ providedIn: "root" })
export class ExpertSchemaService {
  schemaDevImported = false;
  schemaDevSchemas: ProfileElementSchema[] = [];

  getActiveSchemas() {
    // If (and only if) we are running in the special schema development build, pull schemas from the manifest.js import
    if (environment.environmentName === "Schema Development" && !this.schemaDevImported) {
      this.schemaDevImported = true;
      this.schemaDevSchemas = [
        // eslint-disable-next-line @typescript-eslint/dot-notation
        ...window["IMPORTED_SCHEMAS"]
      ];
    }

    // Production will only serve up schemas that are defined in the environment file
    if (environment.production) {
      return this.sortSchemas(environment.expertModeSchemas);
    } else {
      return this.sortSchemas([...environment.expertModeSchemas, ...this.schemaDevSchemas]);
    }
  }

  sortSchemas(schemas: ProfileElementSchema[]) {
    return schemas.sort((a, b) => {
      if (`${a.name}`.toLowerCase() > `${b.name}`.toLowerCase()) {
        return 1;
      } else {
        return -1;
      }
    });
  }
}
